<template>
  <router-view />
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";
export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      resizeTimer: null,
    };
  },
  created() {
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });
  },
  mounted() {
    // 添加窗口尺寸变化监听器
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    // 移除监听器
    window.removeEventListener("resize", this.handleResize);
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  },
  watch: {
    $route: {
        // 监听路由变化时刷新AOS动画
      handler() {
        // 刷新AOS动画
        this.refreshAOS();
      },
      immediate: true,
    },
  },
  methods: {
    // 刷新AOS动画
    refreshAOS() {
      // 延迟执行以确保DOM已更新
      this.$nextTick(() => {
        if (typeof AOS !== "undefined") {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          setTimeout(() => {
            // 刷新AOS动画
            AOS.refresh();

            // 如果需要强制重新触发所有动画
            const aosElements = document.querySelectorAll("[data-aos]");
            aosElements.forEach((element) => {
              element.classList.remove("aos-animate");
            });

            // 重新初始化AOS
            setTimeout(() => {
              AOS.refreshHard();
            }, 0);
          }, 500);
        }
      });
    },
    handleResize() {
      // 防抖处理，避免频繁触发
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }

      this.resizeTimer = setTimeout(() => {
        const currentWidth = window.innerWidth;
        const widthDifference = Math.abs(currentWidth - this.windowWidth);

        // 定义断点
        const mobileBreakpoint = 768;
        const tabletBreakpoint = 992;
        const desktopBreakpoint = 1200;

        // 检查是否跨越了主要断点
        const wasDesktop = this.windowWidth >= desktopBreakpoint;
        const wasTablet = this.windowWidth >= tabletBreakpoint && this.windowWidth < desktopBreakpoint;
        const wasMobile = this.windowWidth < mobileBreakpoint;

        const isDesktop = currentWidth >= desktopBreakpoint;
        const isTablet = currentWidth >= tabletBreakpoint && currentWidth < desktopBreakpoint;
        const isMobile = currentWidth < mobileBreakpoint;

        // 如果设备类型发生变化，则刷新页面
        if ((wasDesktop && !isDesktop) || (wasTablet && !isTablet) || (wasMobile && !isMobile) || widthDifference > 200) {
          // 或者尺寸变化超过200px

          console.log("页面尺寸发生较大变化，自动刷新页面");
          location.reload();
        }

        this.windowWidth = currentWidth;
      }, 500); // 500ms防抖延迟
    },
  },
};
</script>

<!-- col-lg一般用于大屏设备，
(min-width:1200px);

col-md一般用于中屏设备，
(min-width：992px);

col-sm一般用于小屏设备，
(min-width：768px);

col-xs用于超小型设备，
(max-width：768px); -->
